import { useMemo } from 'react'
import { useInView } from 'react-intersection-observer'
import { isEmpty } from 'remeda'
import { ComplementaryProducts } from '@components/ComplementaryProducts/ComplementaryProducts'
import { useRelatedProducts } from '@velasca/hooks/use-related-products'
import { getCompleteTheLookEditorialImage } from '@velasca/utils/get-complete-the-look-editorial-image'
import type { PDPComplementaryProductsProps } from './PDPComplementaryProducts.types'

export const PDPComplementaryProducts = ({
  className,
  sliderStyles,
  productHandle,
  productMedias,
  parentLoading = false,
  arrowVisible = false,
  breakpoints,
  editorialImage,
}: PDPComplementaryProductsProps) => {
  const [ref, inView] = useInView({
    rootMargin: '0px 0px 200px 0px',
    triggerOnce: true,
  })

  const { data, loading } = useRelatedProducts({
    type: 'complementary',
    productHandle,
    skip: !inView,
  })

  const shouldRender = useMemo(() => {
    return !((!data || isEmpty(data)) && !loading && inView)
  }, [data, loading, inView])

  const editorialImageMemo = useMemo(() => {
    return getCompleteTheLookEditorialImage({
      product: {
        editorialImage,
        medias: productMedias,
      },
    })
  }, [editorialImage, productMedias])

  if (!shouldRender) {
    return null
  }

  return (
    <ComplementaryProducts
      ref={ref}
      className={className}
      sliderStyles={sliderStyles}
      products={data}
      loading={loading || parentLoading || !inView}
      arrowVisible={arrowVisible}
      breakpoints={breakpoints}
      editorialImage={editorialImageMemo}
    />
  )
}
